const ContactInfoSection = () => (
  <section id="contact-info" className="relative py-20 px-6 z-10">
    <div className="max-w-5xl mx-auto">
      <div className="text-center mb-12">
        <p className="text-sm uppercase tracking-[0.3em] text-indigo-300">Contact Us</p>
        <h2 className="text-4xl md:text-5xl font-bold text-white mt-4">We are just a call away</h2>
        <p className="mt-6 text-gray-300 max-w-2xl mx-auto leading-relaxed">
          Speak directly with our specialists to explore solutions tailored for your organisation. We are available to support you every step of the way.
        </p>
      </div>

      <div className="grid gap-8 md:grid-cols-3">
        <div className="md:col-span-2 bg-gray-800/40 border border-gray-700/60 rounded-2xl p-8 flex flex-col md:flex-row md:items-center md:justify-between">
          <div className="text-left">
            <h3 className="text-lg font-semibold text-gray-200 uppercase tracking-wide">Call Us</h3>
            <a href="tel:+917496070129" className="mt-3 inline-flex items-baseline gap-2 text-3xl md:text-4xl font-bold text-white">
              <span className="text-indigo-400">+91</span>74960 70129
            </a>
            <p className="mt-4 text-gray-400 text-sm max-w-md">
              Get immediate answers about timelines, pricing, and technical requirements from our solution consultants.
            </p>
          </div>
          <div className="mt-6 md:mt-0">
            <a
              href="#connect"
              onClick={(event) => {
                event.preventDefault();
                const target = document.querySelector('#connect');
                if (target) {
                  target.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
                window.dispatchEvent(new Event('open-connect'));
              }}
              className="inline-flex items-center justify-center bg-indigo-600 hover:bg-indigo-700 text-white px-6 py-3 rounded-lg font-semibold transition-all duration-300"
            >
              Book a Call Online
            </a>
          </div>
        </div>

        <div className="bg-gray-800/30 border border-gray-700/60 rounded-2xl p-8">
          <h3 className="text-lg font-semibold text-gray-200 uppercase tracking-wide">Office Hours</h3>
          <p className="mt-3 text-gray-300">Monday to Saturday</p>
          <p className="text-gray-400 text-sm">9:00 AM – 7:00 PM IST</p>
          <hr className="my-5 border-gray-700/60" />
          <p className="text-sm text-gray-400">Prefer email? Fill out the form and we will follow up within one business day.</p>
        </div>
      </div>
    </div>
  </section>
);

export default ContactInfoSection;
